import { useEffect, useRef } from 'react';

import { isTrue } from '../../../utils';

import { getSSOAlertText } from './helpers';

/**
 * This component checks the current URL query object and sets an info alert telling the user that their organization
 * requires logging in with SSO (LDAP) if the "ldapAuthRequired" query parameter is set. The boolean returned indicates
 * whether LDAP auth is in fact required.
 */
const useLdapAuthRequired = (setAlert: (alert: string) => void, query: Record<string, string> | null): boolean => {
  const isRequired = isTrue(query?.ldapAuthRequired);
  // Invoke this hook only on mount because we don't care about the "setAlert" function changing, and we will show the
  // alert only if the expected query parameter is present when the component mounts.
  const onMount = useRef({ isRequired, setAlert });
  useEffect(() => {
    if (onMount.current.isRequired) {
      onMount.current.setAlert(getSSOAlertText());
    }
  }, []);

  return isRequired;
};

export default useLdapAuthRequired;
